import { jwtDecode } from "./AccessControlUtils";
import { hasRole } from "./roleNames";

/**
 * Main dashboard JWTs have no `roles` — every Auth0 user is an admin.
 * RBAC JWTs include roles; `admin` and `superadmin` / `super-admin` may see Redemption Code.
 */
export const isAdminUser = () => {
    const decoded = jwtDecode();
    if (!decoded) return false;
    const roles = Array.isArray(decoded.roles) ? decoded.roles : [];
    if (roles.length === 0) return true;
    return hasRole(roles, "admin") || hasRole(roles, "superadmin");
};
